<template>
    <div class="margin-tab">
        <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a 
                class="nav-link" 
                @click="itemActive = true"
                :class="[
                    (!modoDark_var && itemActive)? 'active' : '',
                    (modoDark_var && itemActive)? 'DarkActive active' : '',
                    (modoDark_var && itemActive==false)? 'darkInactivo' : ''
                ]"
                id="nav-home-tab" 
                data-toggle="tab"
                href="#nav-home" 
                role="tab" 
                aria-controls="nav-home" 
                aria-selected="true"
                >Agenda Presupuestaria
            </a>
            <a 
                class="nav-link" 
                @click="itemActive = false"
                :class="[
                    (!modoDark_var && !itemActive)? 'active' : '',
                    (modoDark_var && itemActive==false)? 'DarkActive active' : '',
                    (modoDark_var && itemActive==true)? 'darkInactivo' : ''
                ]"
                id="nav-profile-tab" 
                data-toggle="tab" 
                href="#nav-profile" 
                role="tab" 
                aria-controls="nav-profile" 
                aria-selected="false">Agenda Contable
            </a>
        </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
        <div :class="[(itemActive)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <div class="card">
                <div class="card-body">
                    <div class="row card-body">
                        <div class="container text-left mb-3">
                                <h6>Agenda Presupuestaria</h6>
                            </div>
                        <div class="col-7">
                            <!-- AREA DEL SELECT -->
                                <select class="acuerdo1" id="miCombo1" >
                                    <!-- <option value="WY">Seleccionar</option> -->
                                </select>  
                        </div>
                        <div class="col-5">
                            <button @click="consulta1" class="btn btn-vino btn-block">Generar PDF</button>
                        </div>       
                    </div>
                </div>
            </div>
    
        </div>
        <div :class="[(!itemActive)? 'tab-pane fade show active' : 'tab-pane fade',]" role="tabpanel" aria-labelledby="nav-profile-tab">
            <div class="card">
                <div class="card-body">
                    <div class="row card-body">
                            <div class="container text-left mb-3">
                                <h6>Agenda Contable</h6>
                            </div>
                        <div class="col-7">
                           <!-- AREA DEL SELECT -->
                                <select class="acuerdo2" id="miCombo2">
                                    <!-- <option value="WY">Seleccionar</option> -->
                                </select>  
                        </div>
                        <div class="col-5">
                            <button @click="consulta2" class="btn btn-vino btn-block">Generar PDF</button>
                        </div>       
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import axios from "axios";
    import Api from "../../../services/config/api/axios.urlcontext"

    export default {
        data: function(){
            return{
                // ===Agenda Presupuestaria  CHECAR PORQUE NO ME DETECTA LA URL DE LOS JSON
                docAgenda1: '',
                data1: null,
                jsonAgenda1: Api.APP_URL_API+'/Legislacion/Estatal/Convenios-y-Otros/AgendaPresupuestaria.json',
                // ===Agenda Contable
                docAgenda2: '',
                data2: null,
                jsonAgenda2: Api.APP_URL_API+'/Legislacion/Estatal/Convenios-y-Otros/AgendaContable.json',
                
                itemActive: true
               
            }
        },
        methods:{
            proceso(_combo){
                    const UrlServer = this.jsonAgenda1;
                    $.get(UrlServer, function (data) {
                        $("#" + _combo).empty();
                        data[0].Anios_acuerdos = data[0].Anios_acuerdos.reverse()
                        $.each(data[0].Anios_acuerdos, function (indice, row) {            
                              $("#" + _combo).append("<option value='" + row.url + "'>" + row.anio + "</option>");
                                // console.log(data[0].Anios_acuerdos);
                                // this.data = row.datos[0].ano;
                            });
                            $("#" + _combo).select();
                        })
                        .fail(function (result) {
                            console.log("Ocurrio un error, intente de nuevo. " + result.responseText);
                        });
                },
            proceso2(_combo){
                    const UrlServer = this.jsonAgenda2;
                    $.get(UrlServer, function (data) {
                        $("#" + _combo).empty();
                        data[0].Anios_acuerdos = data[0].Anios_acuerdos.reverse()
                        $.each(data[0].Anios_acuerdos, function (indice, row) {            
                              $("#" + _combo).append("<option value='" + row.url + "'>" + row.anio + "</option>");
                                // console.log(data[0].Anios_acuerdos);
                                // this.data = row.datos[0].ano;
                            });
                            $("#" + _combo).select();
                        })
                        .fail(function (result) {
                            console.log("Ocurrio un error, intente de nuevo. " + result.responseText);
                        });
                },
            consulta1(){
                    var urlServe = this.urlServe;
                    this.docAgenda1 = document.getElementById('miCombo1').value;
                    // console.log(this.docAgenda1);
                    window.open(urlServe+ this.docAgenda1);
                },
            
            consulta2(){
                    var urlServe = this.urlServe;
                    this.docAgenda2 = document.getElementById('miCombo2').value;
                    // console.log(this.docAgenda2);
                    window.open(urlServe+ this.docAgenda2);
                },
    
            
        },
        created: function(){
            $('.acuerdo1').select2();
            $('.acuerdo2').select2();
            this.proceso('miCombo1');
            this.proceso2('miCombo2');
    
    
        },
        mounted () {
            /* llena la variable data con el json del primer bloque de acuerdos */
                axios
                .get(this.jsonAgenda1)
                .then(response => (this.data1 = response.data))
                axios
                .get(this.jsonAgenda2)
                .then(response => (this.data2 = response.data))
        },
        computed:{ ...mapState(['modoDark_var']) },
        watch:{
            
            
        }
    }
    </script>
        
    
    <style scoped>
    .nav-link{ color: #621132 !important; }
    .darkInactivo{ color: white !important; }
    .margin-tab{ width: 90%; }
    .nav-tabs {
        border-bottom: none;
        justify-content: end;
     }
    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
        color: #621132;
    }
    a{ color: #4d4d4d;}
    a:hover { color: #ad0d33 !important; }  /**/
    .card-body { min-height: 1px; }
    h6{ font-weight: 400; }
    
    #miCombo1{
            width: 100%;
            height: 100%;
            border-radius: 5px;
            border: 1px solid #d9d4d4;
            font-size: 18px;
            color: #4e4a4a;
            padding: .5rem;
        }
    #miCombo2{
            width: 100%;
            height: 100%;
            border-radius: 5px;
            border: 1px solid #d9d4d4;
            font-size: 18px;
            color: #4e4a4a;
            padding: .5rem;
        }
        select:focus{ outline: none;}
    
    @media only screen and (max-device-width : 900px) {
        a { font-size: 14px; }
    
        h6 { font-size: 13px; }
    
        .form-control-lg {  
            padding: .5rem .3rem;
            font-size: 0.9rem;
        }
    
        .btn{
            padding: .5rem .9rem;
            font-size: .7rem;
        }
    
        /* propiedades del card de consultar año */
        .card-body{ padding: .8rem; }
        .col-7{
            padding-right: 5px !important;
            padding-left: 5px !important;
        }
        .col-5{
            padding-right: 5px !important;
            padding-left: 5px !important;
        }
    
        .sec_imagen { margin-left: 0 !important; }
        .nav{flex-wrap: nowrap;}
    
    
    }
    
    
    </style>